(function () {
  'use strict';
  if (window.__MIFO_NZ_ATTRIBUTION__) return;
  var host = location.hostname.toLowerCase();
  var store = /^(www\.)?mifo\.co\.nz$/.test(host);
  var publisher = /^(www\.)?techbest\.com\.au$/.test(host);
  if (!store && !publisher) return;
  var api = 'https://techbest.com.au/wp-json/mifo-nz/v1/';
  var campaigns = ['21721316390'];
  var campaign = new URLSearchParams(location.search).get('tb_gads_campaign_id') || '';
  function campaignAllowed() { return campaigns.indexOf(campaign) !== -1; }
  var key = 'mifo_nz_attribution_v1';
  var rawFetch = window.fetch.bind(window);
  var params = new URLSearchParams(location.search);
  var token = params.get('mn_at') || '';
  var capturePromise;
  var cartPromise;
  var consentLoaded = false;
  var lastError = '';
  var lastCartToken = '';
  var declined = false;
  var storefrontVerified = false;
  var input = {
    gclid: params.get('gclid') || '', gbraid: params.get('gbraid') || '', wbraid: params.get('wbraid') || '',
    campaign_id: params.get('tb_gads_campaign_id') || '',
    ad_group_id: params.get('tb_gads_ad_group_id') || '', creative_id: params.get('tb_gads_creative_id') || '',
    landing: location.origin + location.pathname, qa: params.get('mifo_tracking_qa') === '1'
  };
  var fallbackKeys = ['gclid', 'gbraid', 'wbraid', 'tb_gads_campaign_id', 'tb_gads_ad_group_id', 'tb_gads_creative_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'market', 'mifo_tracking_qa'];
  function allowed() {
    if (navigator.globalPrivacyControl === true || declined) return false;
    if (!store) return !window.__consentState || window.__consentState.ad_storage !== 'denied';
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && privacy.marketingAllowed()); } catch (_) { return false; }
  }
  function personalization() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return allowed() && privacy && privacy.saleOfDataAllowed() ? 'GRANTED' : 'DENIED'; } catch (_) { return 'DENIED'; }
  }
  function timeoutFetch(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, url.indexOf(api) === 0 ? 6000 : 1800);
    return rawFetch(url, Object.assign({}, options, { signal: controller.signal })).finally(function () { clearTimeout(timer); });
  }
  function post(path, data) {
    return timeoutFetch(api + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('tracking_http_' + r.status); return r.json(); });
  }
  function remember() {
    if (!allowed() || !token) return;
    var value = JSON.stringify({ token: token, campaign: campaign, expires: Date.now() + 30 * 86400000 });
    try { localStorage.setItem(key, value); } catch (_) {}
    document.cookie = key + '=' + encodeURIComponent(value) + '; Max-Age=2592000; Path=/; SameSite=Lax; Secure';
  }
  function restore() {
    if (token || input.gclid || input.gbraid || input.wbraid || !allowed()) return;
    var value = '';
    try { value = localStorage.getItem(key) || ''; } catch (_) {}
    if (!value) {
      var part = document.cookie.split('; ').find(function (x) { return x.indexOf(key + '=') === 0; });
      if (part) { try { value = decodeURIComponent(part.slice(key.length + 1)); } catch (_) {} }
    }
    try { var record = JSON.parse(value); if (record.expires > Date.now()) { token = record.token || ''; campaign = record.campaign || campaign; } } catch (_) {}
  }
  function decorate() {
    if (!publisher) return;
    document.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.protocol !== 'https:') return;
      if (!/^(www\.)?mifo\.co\.nz$/.test(url.hostname)) return;
      if (!allowed()) { url.searchParams.delete('mn_at'); a.href = url.toString(); return; }
      if (token) {
        url.searchParams.set('mn_at', token);
        ['gclid', 'gbraid', 'wbraid'].forEach(function (k) { url.searchParams.delete(k); });
      } else if (campaignAllowed()) {
        fallbackKeys.forEach(function (k) { var v = params.get(k); if (v) url.searchParams.set(k, v); });
      }
      if (token || campaignAllowed()) {
        url.searchParams.set('utm_source', 'google'); url.searchParams.set('utm_medium', 'cpc');
        url.searchParams.set('utm_campaign', 'mifo_nz_earbuds'); url.searchParams.set('market', 'nz');
      }
      a.href = url.toString();
    });
  }
  function capture() {
    if (!allowed()) return Promise.resolve('');
    if (capturePromise) return capturePromise;
    restore();
    if (!token && (!input.gclid && !input.gbraid && !input.wbraid || !campaignAllowed())) return Promise.resolve('');
    capturePromise = post('touch', token ? { token: token } : input).then(function (data) {
      token = data.token; campaign = data.campaignId || campaign; remember(); decorate(); return token;
    }).catch(function (e) { lastError = e.message; return ''; }).finally(function () { capturePromise = null; });
    return capturePromise;
  }
  function attributes() {
    if (!token || !allowed()) return {};
    return { mifo_nz_attribution__: token, mifo_nz_marketing_consent__: 'GRANTED', mifo_nz_personalization__: personalization(), mifo_nz_campaign__: campaign };
  }
  function syncCart(forceClear) {
    if (!store) return Promise.resolve();
    if (cartPromise) return forceClear ? cartPromise.then(function () { return syncCart(true); }) : cartPromise;
    if (!forceClear && (!token || !allowed())) return Promise.resolve();
    var attrs = forceClear ? { mifo_nz_attribution__: '', mifo_nz_marketing_consent__: 'DENIED', mifo_nz_personalization__: 'DENIED', mifo_nz_campaign__: '' } : attributes();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    cartPromise = timeoutFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (!r.ok) throw new Error('cart_tracking_http_' + r.status); return r.json(); })
      .then(function (cart) {
        lastCartToken = cart.token || lastCartToken;
        if (!lastCartToken) return;
        // The signed private cart attribute is authoritative; the cart mapping is a background fallback.
        post('attach', { token: token, cart_token: lastCartToken, consent: forceClear || !allowed() ? 'DENIED' : 'GRANTED', personalization: personalization() }).catch(function (e) { lastError = e.message; });
      }).catch(function (e) { lastError = e.message; }).finally(function () { cartPromise = null; });
    return cartPromise;
  }
  function initialiseStore() {
    consentLoaded = true;
    if (!allowed()) {
      var stored = false;
      try { stored = !!localStorage.getItem(key); localStorage.removeItem(key); } catch (_) {}
      document.cookie = key + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
      return stored ? syncCart(true) : Promise.resolve();
    }
    return capture().then(function () { return syncCart(false); });
  }
  function privacyReady() {
    if (window.Shopify && window.Shopify.customerPrivacy) return initialiseStore();
    return new Promise(function (resolve) {
      var done = false;
      var interval, timer;
      function finish() { if (done) return; done = true; clearInterval(interval); clearTimeout(timer); resolve(initialiseStore()); }
      interval = setInterval(function () { if (window.Shopify && window.Shopify.customerPrivacy) finish(); }, 100);
      timer = setTimeout(finish, 2500);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      }
    });
  }
  window.__MIFO_NZ_ATTRIBUTION__ = {
    ready: function () { return store ? ready : capture(); },
    status: function () { return { market: 'nz', hasToken: !!token, consentReady: consentLoaded, marketingAllowed: allowed(), storefrontVerified: storefrontVerified, lastError: lastError }; }
  };
  var ready = Promise.resolve();
  if (publisher) {
    decorate(); capture();
    document.addEventListener('click', decorate, true);
    document.addEventListener('auxclick', decorate, true);
    var observer = new MutationObserver(decorate);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('visitorConsentCollected', function () {
      if (!allowed()) {
        try { localStorage.removeItem(key); } catch (_) {}
        document.cookie = key + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
        token = ''; decorate();
      } else capture();
    });
  } else {
    // Save attributes before returning add-to-cart responses to storefront checkout code.
    window.fetch = function (resource, options) {
      var url;
      try { url = new URL(typeof resource === 'string' ? resource : resource.url, location.href); } catch (_) { return rawFetch(resource, options); }
      // The athletics storefront creates a separate Storefront API cart. Keep its
      // existing attributes and attach our signed NZ attribution to that actual cart.
      if (url.hostname === 'mifo-new-zealand.myshopify.com' && /^\/api\/[^/]+\/graphql\.json$/.test(url.pathname) && options && typeof options.body === 'string') {
        var body;
        try { body = JSON.parse(options.body); } catch (_) {}
        if (body && /\bcartCreate\s*\(/.test(body.query || '') && body.variables && body.variables.input) {
          return Promise.race([ready.then(capture), new Promise(function (resolve) { setTimeout(resolve, 1800); })]).then(function () {
            var values = attributes();
            if (!Object.keys(values).length) return rawFetch(resource, options);
            var existing = Array.isArray(body.variables.input.attributes) ? body.variables.input.attributes : [];
            body.variables.input.attributes = existing.filter(function (a) { return !Object.prototype.hasOwnProperty.call(values, a.key); }).concat(Object.keys(values).map(function (key) { return { key: key, value: values[key] }; }));
            return rawFetch(resource, Object.assign({}, options, { body: JSON.stringify(body) })).then(function (response) {
              if (!response.ok) return response;
              return response.clone().json().then(function (data) {
                var cart = data.data && data.data.cartCreate && data.data.cartCreate.cart;
                if (!cart || !cart.id) return response;
                var saved = {}; (cart.attributes || []).forEach(function (a) { saved[a.key] = a.value; });
                storefrontVerified = Object.keys(values).every(function (key) { return saved[key] === values[key]; });
                if (!storefrontVerified) { lastError = 'storefront_attributes_missing'; return response; }
                var cartToken = cart.id.replace(/^gid:\/\/shopify\/Cart\//, '').split('?')[0];
                return Promise.race([post('attach', { token: token, cart_token: cartToken, consent: allowed() ? 'GRANTED' : 'DENIED', personalization: personalization() }).catch(function (e) { lastError = e.message; }), new Promise(function (resolve) { setTimeout(resolve, 1200); })]).then(function () { return response; });
              }).catch(function (e) { lastError = e.message; return response; });
            });
          });
        }
      }
      var cartWrite = url.origin === location.origin && /\/cart\/(add|change|update)(\.js)?$/.test(url.pathname) && String(options && options.method || resource.method || 'GET').toUpperCase() === 'POST';
      if (!cartWrite) return rawFetch(resource, options);
      return rawFetch(resource, options).then(function (response) {
        if (!response.ok) return response;
        return Promise.race([
          ready.then(function () { return syncCart(false); }),
          new Promise(function (resolve) { setTimeout(resolve, 1800); })
        ]).then(function () { return response; });
      });
    };
    ready = privacyReady();
    document.addEventListener('visitorConsentCollected', function () {
      declined = false;
      if (!allowed()) {
        declined = true;
        try { localStorage.removeItem(key); } catch (_) {}
        document.cookie = key + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
        syncCart(true); token = '';
      } else { declined = false; ready = initialiseStore(); }
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button > 0 || !token || !allowed()) return;
      var dest = new URL(link.href, location.href);
      if (dest.origin !== location.origin || !/\/checkout\/?$/.test(dest.pathname)) return;
      event.preventDefault();
      Promise.race([ready.then(function () { return syncCart(false); }), new Promise(function (r) { setTimeout(r, 1200); })]).finally(function () { location.assign(dest.href); });
    }, true);
    var submitting = false;
    document.addEventListener('submit', function (event) {
      if (submitting || !token || !allowed()) return;
      var form = event.target;
      var action;
      try { action = new URL(form.action, location.href); } catch (_) { return; }
      var submitter = event.submitter;
      var checkout = submitter && (submitter.name === 'checkout' || submitter.getAttribute('formaction') === '/checkout');
      if (action.origin !== location.origin || !checkout && !/\/checkout\/?$/.test(action.pathname)) return;
      event.preventDefault();
      Promise.race([ready.then(function () { return syncCart(false); }), new Promise(function (resolve) { setTimeout(resolve, 1200); })]).finally(function () {
        submitting = true;
        try { form.requestSubmit(submitter || undefined); } finally { submitting = false; }
      });
    }, true);
  }
})();
